export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: undefined
    },

    label: {
      type: String,
      default: undefined
    },

    required: {
      type: Boolean,
      default: false
    },

    align: {
      type: String,
      default: undefined,
      validator: (v) => ['left', 'right', 'center'].indexOf(v) >= 0
    },

    variant: {
      type: String,
      default: undefined,
      validator: (v) => ['success', 'info', 'warning', 'danger'].indexOf(v) >= 0
    },

    prepend: {
      type: String,
      default: undefined
    },

    append: {
      type: String,
      default: undefined
    },

    inputClass: {
      default: undefined
    },

    plaintext: {
      type: Boolean,
      default: false
    }
  }
};
